import React, { useMemo } from 'react';
import FeatureToggleContext from './FeatureToggleContext';

interface FeatureToggleProviderProps {
  children: React.ReactNode;
  featureToggles: Dictionary<boolean>;
}

const FeatureToggleProvider = ({ children, featureToggles }: FeatureToggleProviderProps) => {
  const contextValue = useMemo(
    () => ({
      isFeatureEnabled: (featureName: string) => Boolean(featureToggles?.[featureName]),
    }),
    [featureToggles],
  );

  return <FeatureToggleContext.Provider value={contextValue}>{children}</FeatureToggleContext.Provider>;
};

export default FeatureToggleProvider;
